"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.themes = exports["default"] = void 0;
var _reactCssThemr = require("react-css-themr");
var _ModalFooter = _interopRequireDefault(require("./ModalFooter"));
// themes
require("./themes/DefaultTheme.css");
var DefaultTheme = {
  "modal-footer": "DefaultTheme__modal-footer___YOV-y",
  "modalFooter": "DefaultTheme__modal-footer___YOV-y"
};
require("./themes/DarkTheme.css");
var DarkTheme = {
  "modal-footer": "DarkTheme__modal-footer___33zUk",
  "modalFooter": "DarkTheme__modal-footer___33zUk"
};
require("./themes/LumeTheme.css");
var LumeTheme = {
  "modal-footer": "LumeTheme__modal-footer___20f-j",
  "modalFooter": "LumeTheme__modal-footer___20f-j"
};
var themes = exports.themes = {
  DefaultTheme: DefaultTheme,
  DarkTheme: DarkTheme,
  LumeTheme: LumeTheme
};
var ThemedComponent = (0, _reactCssThemr.themr)(_ModalFooter["default"].displayName, themes.DefaultTheme)(_ModalFooter["default"]);
ThemedComponent.displayName = _ModalFooter["default"].displayName;
ThemedComponent.themes = themes;
var _default = exports["default"] = ThemedComponent;
//# sourceMappingURL=index.js.map